// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__gJRd0","loginLoading":"LoginPage_loginLoading__7W5zY","spinner":"LoginPage_spinner__Dna55"};